import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
// hooks
import useAuth from '../hooks/useAuth';

// ----------------------------------------------------------------------

LoginWebGuard.propTypes = {
  children: PropTypes.node
};

export default function LoginWebGuard({ children }) {
  const { isAuthenticated, isWebVersion } = useAuth();

  if ( !isWebVersion() ) {
    return <Navigate to="/auth/login" />;
  }
  
  if ( isAuthenticated ) {
    return <Navigate to="/" />;
  }

  return <>{children}</>;
}
